import React from 'react';
import axios from 'axios';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DateUtils } from 'react-day-picker';
import {formatDate,parseDate,} from 'react-day-picker/moment';

import setMinutes from "date-fns/set_minutes";
import setHours from "date-fns/set_hours";
import format from "date-fns/format";
import parse from 'date-fns/parse';

import validator from 'validator';
import Storage from '../util/Storage';
import GtmHelper from '../util/GtmHelper';
import BookingService from './BookingService.jsx';
import BookingSummary from './BookingSummary.jsx';
import SearchInput from './SearchInput.jsx';
import FabeSelect from './FabeSelect.jsx';
import FabeInputText from './FabeInputText.jsx';
import ModalSelect from './ModalSelect.jsx';
import ModalServices from './ModalServices.jsx';
import BookingFormValidator from '../util/validators/BookingFormValidator';
import BookingSuccess from './BookingSuccess.jsx';
import LoadingScreen from './LoadingScreen.jsx';
import Api from '../util/Api';
import BoutiqueHours from '../util/BoutiqueHours';
import BookingUpsells from './BookingUpsells.jsx';

export const personBgColors = ['bg-green', 'bg-blue', 'bg-purple', 'bg-red'];

const MultipleBooking = (props) => {

    const selectOptions = [
        {
            name: '2 persons',
            value: 2
        },{
            name: '3 persons',
            value: 3
        },{
            name: '4 persons',
            value: 4
        },
    ];

    function getSelected(value) {
        const selected = selectOptions.find((opt) => opt.value === value);
        return selected ? selected : { name: '', value: '' };
    }

    function handleCheckboxChange(value) {
        if (props.multipleBookingChecked) {
            props.handleClientsCountChange(1);
        } else {
            props.handleClientsCountChange(2);
        }
        props.handleCheckboxChange(value);
    }

    return (
        <div className="booking-form__multiple-booking">
            <div className="w-full booking-form__input-wrapper">
                <label className="checkbox">
                    <span className="checkbox__title">Booking for more than one person?</span>
                    <input type="checkbox" name="multipleBookingChecked" onChange={handleCheckboxChange} defaultChecked={props.multipleBookingChecked} value={props.multipleBookingChecked} />
                    <span className="checkmark" />
                </label>
            </div>
            {props.multipleBookingChecked &&
                <div className="w-full booking-form__input-wrapper">
                    <FabeSelect
                        placeholder={getSelected(props.clientCount).name}
                        label={trans.number_of_clients}
                        options={selectOptions}
                        changeHandler={props.handleClientsCountChange}
                        value={getSelected(props.clientCount).value}
                    />
                </div>
            }
        </div>
    );
}

class BookingForm extends React.Component {
    constructor () {
        super();

        this.validator = BookingFormValidator;

        this.state = this.getEmptyState();

        this.extraChangeHandler = this.extraChangeHandler.bind(this);
        this.handleClientsCountChange = this.handleClientsCountChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.handleProfessionalsChange = this.handleProfessionalsChange.bind(this);
        this.handleBoutiquesChange = this.handleBoutiquesChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.changeServicePerson = this.changeServicePerson.bind(this);

        this.contactsBlockRef = React.createRef();
        this.formBlockRef = React.createRef();
        this.detailsBlockRef = React.createRef();
    }

    getEmptyState() {
        const contactInfo = Storage.getItem(Storage.KEY_CONTACT_INFO);

        return {
            submitted: false,
            loading: false,
            professionals: [],
            boutiques: [],
            services: Storage.getItem(Storage.KEY_SERVICES) || [],
            clientsCount: 1,
            date: Date.now(),
            time: undefined,
            comments: "",
            name: contactInfo && contactInfo.name || '',
            phone: contactInfo && contactInfo.phone || '',
            email: contactInfo && contactInfo.email || '',
            rememberInfoChecked: contactInfo && contactInfo.rememberInfoChecked || false,
            selectedBoutique: null,
            selectedBoutiquesString: trans.any_boutique,
            selectedProfessionalsString: trans.any_professional,
            validation: this.validator.valid(),
            showModalSelectBoutique: false,
            showModalSelectProfessionals: false,
            showModalSelectServices: false,
            orderEmail: "",
            choseTime: false,
            choseDate: false,
            multipleBookingChecked: false,
            searchText: "",
        }
    }

    handleClientsCountChange(value) {
        this.setState({ clientsCount: value })
    }

    handleDateChange(value) {
        this.setState({
            date: value,
            choseDate: true,
            choseTime: false,
            time: undefined
        })
    }

    handleTimeChange(value) {
        this.setState({ time: value, choseTime: true })
    }

    changeServicePerson(serviceId, newPerson) {
        const newServices = this.state.services.map((service) => {
            if (service.id !== serviceId) {
                return service;
            }
            return {
                ...service,
                person: newPerson
            }
        });
        this.setState({
            services: newServices
        }, () => {
            Storage.setItem(Storage.KEY_SERVICES, this.state.services);
        });
    }

    duplicateItem(item) {
        const itemCopy = JSON.parse(JSON.stringify(item)); //Object.assign({}, item);
        if ((itemCopy.person || 1) + 1 <= this.state.clientsCount) {
            itemCopy.person = (itemCopy.person || 1) + 1;
        }
        this.handleServiceAddClick(itemCopy);
    }

    handleInputChange(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    handleCheckboxChange(event) {
        this.setState({ [event.target.name]: event.target.checked })
    }

    handleProfessionalsChange(value) {
        this.setState(state => {
            const professionals = state.professionals.map((item, index) => {
                if (item.id === value.id) {
                    item.checked = !item.checked;
                } else {
                    item.checked = false;
                }

                return item;
            });

            return {
                professionals: professionals,
                selectedProfessionalsString: value.title
            };
        });
    }

    // parseDate(str, strformat, locale) {
    //     console.log(str, strformat);
    //     const parsed = parse(str, strformat, { locale });

    //     console.log(parsed);
    //     if (DateUtils.isDate(parsed)) {
    //         return parsed;
    //     }
    //     return undefined;
    // }

    // formatDate(date, strformat, locale) {
    //     console.log(date, strformat);
    //     return format(date, strformat, { locale });
    // }

    handleBoutiquesChange(value) {
        let selectedBoutique = null;

        const boutiques = this.state.boutiques.map((item, index) => {
            if (item.id === value.id) {
                item.checked = true;
                selectedBoutique = item;
            } else {
                item.checked = false;
            }

            return item;
        });

        this.fetchProfessionals(selectedBoutique.id);

        this.setState({
            boutiques: boutiques,
            selectedBoutique: selectedBoutique,
            orderEmail: value.orderEmail,
            selectedBoutiquesString: value.name,
            choseTime: false,
            time: undefined
        });
    }

    servicesSelected() {
        const that = this;
        return this.state.services.map(function(item, index) {
            return (
                <BookingService
                    key={item.id}
                    id={item.id}
                    title={item.title}
                    duration={item.duration}
                    description={item.description}
                    extras={item.extras}
                    price={item.price}
                    salesPrice={item.sales_price}
                    isOnSale={item.is_on_sale}
                    removeHandler={(e) => that.handleServiceRemoveClick(e, item.id)}
                    extraChangeHandler={that.extraChangeHandler}
                    person={item.person || 1}
                    changeServicePerson={that.changeServicePerson}
                    clientsCount={that.state.clientsCount}
                    duplicateItem={() => that.duplicateItem(item)}
                />
            );
        });
    }

    fetchProfessionals(locationId) {
        Api.getProfessionals(locationId, professionals => {
            this.setState({
                professionals: professionals,
                selectedProfessionalsString: trans.any_professional
            })
        })
    }

    getMainBoutique(boutiques) {
        let main = boutiques[0];
        boutiques.forEach(function(boutique) {
            if (boutique.mainLocation) {
                main = boutique;
            }
        });

        return main;
    }

    fetchBoutiques() {
        Api.getBoutiques(boutiques => {
            boutiques[0].checked = true;
            this.setState({
                boutiques: boutiques,
                selectedBoutique: boutiques[0],
                orderEmail: boutiques[0].orderEmail,
                selectedBoutiquesString: boutiques[0].name // preselect first
            })
        })
    }

    fetchServices() {
        this.setState({ services: Storage.getItem(Storage.KEY_SERVICES) || [] });
    }

    extraChangeHandler(checked, serviceId, extra) {
        const newServices = this.state.services.map(function(item) {

            if (item.id === serviceId) {
                item.extras.forEach(function(ex) {
                    if (ex.title === extra.title) {
                        ex.checked = checked;
                    }
                })
            }

            return item;
        });

        this.setState({ services: newServices }, () => {
            Storage.setItem(Storage.KEY_SERVICES, this.state.services);
        });
    }

    handleServiceRemoveClick(e, id) {
        this.setState({ services: this.state.services.filter(function(service) {
            return service.id !== id
        })}, () => {
            Storage.setItem(Storage.KEY_SERVICES, this.state.services);
        });

        e.preventDefault();
    }

    handleServiceAddClick(item) {
        // TODO: find a better way?
        let itemCopy = Object.assign({}, item);
        itemCopy.id = item.id + new Date().getTime();

        GtmHelper.addToCart(item);

        let updatedServices = this.state.services;
        updatedServices.push(itemCopy);

        this.setState({ services: updatedServices });

        Storage.setItem(Storage.KEY_SERVICES, this.state.services);
    }

    getTotal() {
        let total = 0;

        this.state.services.forEach(function(item) {
            if (item.is_on_sale) {
                total += parseFloat(item.sales_price.value) || 0;
            } else {
                total += parseFloat(item.price.value) || 0;
            }

            item.extras.forEach(function(item) {
                if (item.checked) {
                    total += parseFloat(item.price);
                }
            })
        });

        return total; // * this.state.clientsCount;
    }

    componentDidMount() {
        // this.fetchServices();
        this.fetchBoutiques();
        this.fetchProfessionals();

        GtmHelper.viewBookings(Storage.getItem(Storage.KEY_SERVICES) || []);
        // this.loadContactInfo();
    }

    getPostData() {
        let data = {};

        Object.keys(this.state).forEach(key => {
            if (key == "date") {
                data[key] = format(this.state.date, 'Do of MMMM YYYY');
            } else {
                data[key] = this.state[key];
            }
        })

        data["total"] = this.getTotal() + trans.currency_append;
        return data;
    }

    getContactInfo() {
        return {
            email: this.state.email,
            phone: this.state.phone,
            name: this.state.name,
            rememberInfoChecked: this.state.rememberInfoChecked
        }
    }

    saveContactInfo(isChecked) {
        if (isChecked) {
            Storage.setItem(Storage.KEY_CONTACT_INFO, this.getContactInfo())
        } else {
            Storage.setItem(Storage.KEY_CONTACT_INFO, {})
        }
    }

    isAllClientsHaveServices() {
        if (this.state.clientsCount > 1) {
            const uniqueClient = this.state.services.map(item => item.person || 1).filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            if (uniqueClient.length !== this.state.clientsCount) {
                return false;
            }
        }
        return true;
    }

    /**
     * takes into account service length, clients count
     */
    isServicesValid() {
        if (this.state.services.length <= 0) {
            return false;
        }
        return this.isAllClientsHaveServices();
    }

    handleSubmit(e) {
        const validation = this.validator.validate(this.state);
        this.setState({ validation });
        this.setState({ submitted: true })

        if (!this.isServicesValid()) {
            window.scrollTo(0, this.formBlockRef.current.offsetTop - 100);
            e.preventDefault();
            return;
        }

        if (!this.state.choseTime) {
            window.scrollTo(0, this.detailsBlockRef.current.offsetTop - 100);
            e.preventDefault();
            return;
        }

        if (!this.state.choseDate) {
            window.scrollTo(0, this.detailsBlockRef.current.offsetTop - 100);
            e.preventDefault();
            return;
        }

        if (validation.isValid) {
            GtmHelper.makeAppointment(Storage.getItem(Storage.KEY_SERVICES) || []);

            this.saveContactInfo(this.state.rememberInfoChecked);

            this.setState({ loading: true });

            Api.makeAppointment(this.getPostData(), (success, response) => {
                GtmHelper.confirmBooking(Storage.getItem(Storage.KEY_SERVICES) || [], this.getTotal(), new Date().getTime() + Math.floor(Math.random() * 101))
                this.setState({ loading: false, success: success, submitted: false });
                this.setState(this.getEmptyState());
                // this.loadContactInfo();
                Storage.setItem(Storage.KEY_SERVICES, []);
            })
        } else {
            window.scrollTo(0, this.contactsBlockRef.current.offsetTop);
        }

        e.preventDefault();
    }

    renderBoutiqueInput() {
        return (
            <div className="w-full md:w-1/2 booking-form__input-wrapper" onClick={(e) => {this.setState({showModalSelectBoutique: true})}}>
                <FabeSelect
                    label={trans.select_boutique_label}
                    placeholder={this.state.selectedBoutiquesString}
                    options={[trans.any_boutique]}
                    preventClick={true}
                />
            </div>
        )
    }

    getDisabledDates() {
        let disabledDates = [];
        if (this.props.allowBookingDate) {
            disabledDates.push({before: new Date(this.props.allowBookingDate)})
        } else {
            disabledDates.push({before: new Date()})
        }
        if (this.props.disabledDates && Array.isArray(this.props.disabledDates)) {
            this.props.disabledDates.map((date) => {
                disabledDates.push(new Date(date));
            })
        }
        return disabledDates;
    }


    renderForm() {
        let validation = this.state.submitted
            ? this.validator.validate(this.state)
            : this.state.validation;

        const FORMAT = 'Do of MMMM YYYY';

        return (
            <form className="booking-form flex flex-col xl:flex-row" onSubmit={this.handleSubmit} ref={this.formBlockRef}>
                <div className="w-full xl:w-2/3">
                    <div className="booking-form__block">
                        <h2 className="booking-form__title">
                            { this.state.success ? trans.thank_you : trans.booking_form_title }
                        </h2>
                        <MultipleBooking
                            multipleBookingChecked={this.state.multipleBookingChecked}
                            handleCheckboxChange={this.handleCheckboxChange}
                            handleClientsCountChange={this.handleClientsCountChange}
                            clientCount={this.state.clientsCount}
                        />
                        {!this.isAllClientsHaveServices() && this.state.submitted && <div className={'bg-fifth-red text-white rounded-sm p-4 mb-2'}>
                            Booking for more than one person is chosen but not all people have services. Please assign services to each person.
                        </div>}
                        { this.servicesSelected() }
                        <SearchInput
                            placeholder={trans.add_more_services}
                            addServiceHandler={this.handleServiceAddClick.bind(this)}
                            error={this.state.submitted ? !this.isServicesValid() : false}
                            openServicesModal={() => this.setState({
                                showModalSelectServices: true
                            })}
                            handleSearchInputChange={(searchText) => this.setState({
                                searchText
                            })}
                        />
                    </div>
                    <BookingUpsells
                        services={this.state.services}
                        handleServiceAddClick={this.handleServiceAddClick.bind(this)}
                    />
                    <div className="booking-form__block" ref={this.detailsBlockRef}>
                        <h2 className="booking-form__title">{ trans.booking_details }</h2>
                        <div className="flex flex-wrap">
                            { this.state.boutiques && this.state.boutiques.length > 2 ? this.renderBoutiqueInput() : '' }

                          {this.state.boutiques &&
                          (this.state.boutiques.length <= 2 || (this.state.boutiques.length > 2 && this.state.selectedBoutique.id !== 0)) &&
                          <div className="w-full md:w-1/2 booking-form__input-wrapper" onClick={(e) => {
                            this.setState({showModalSelectProfessionals: true})
                          }}>
                            <FabeSelect
                              label={trans.select_professional_label}
                              placeholder={this.state.selectedProfessionalsString}
                              options={[trans.any_professional]}
                              preventClick={true}
                            />
                          </div>
                          }
                        </div>
                        <div className="flex flex-col md:flex-row">
                            <div className={"w-full md:w-1/3 booking-form__input-wrapper " + (!this.state.choseDate && this.state.submitted && "has-error")}>
                                <div className="fabe-input flex flex-wrap date">
                                    <label className="fabe-input__label">{trans.date}</label>
                                    <div className="w-full">
                                        <DayPickerInput
                                            onDayChange={this.handleDateChange}

                                            formatDate={formatDate}
                                            parseDate={parseDate}
                                            format={FORMAT}

                                            dayPickerProps={{
                                                disabledDays: this.getDisabledDates(),
                                                initialMonth: new Date(),
                                                fromMonth: new Date()
                                            }}
                                            placeholder={""}
                                            inputProps={{ readOnly: true }}
                                        />
                                    </div>
                                    <i className="far fa-calendar-alt"></i>
                                </div>
                            </div>
                            <div className={"w-full md:w-1/3 booking-form__input-wrapper " + (!this.state.choseTime && this.state.submitted && "has-error")}>
                                <div className="fabe-input flex flex-wrap time">
                                    <label className="fabe-input__label">{trans.time}</label>
                                    <div className="w-full">
                                        <FabeSelect
                                            placeholder={this.state.time}
                                            value={this.state.time}
                                            options={BoutiqueHours.getTimesArray(this.state.selectedBoutique, this.state.date)}
                                            changeHandler={(value) => { this.setState({ time: value, choseTime: true }) }}
                                        />
                                    </div>
                                    <i className='far fa-clock'></i>
                                </div>
                            </div>
                        </div>
                        <div className="flex">
                            <div className="w-full md:w-2/3 booking-form__input-wrapper">
                                <FabeInputText
                                    name="comments"
                                    label={trans.comment_or_requirement}
                                    value={this.state.comments}
                                    changeHandler={this.handleInputChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div ref={this.contactsBlockRef} className="booking-form__block booking-form__block--space-above">
                        <h2 className="booking-form__title">{ trans.personal_details }</h2>
                        <div className="flex flex-col md:flex-row">
                            <div className={"w-full md:w-3/5 booking-form__input-wrapper " + (validation.name.isInvalid && "has-error")}>
                                <FabeInputText
                                    name="name"
                                    label={trans.full_name}
                                    placeholder={trans.required}
                                    value={this.state.name}
                                    changeHandler={this.handleInputChange}
                                />
                            </div>
                            <div className={"w-full md:w-2/5 booking-form__input-wrapper " + (validation.phone.isInvalid && "has-error")}>
                                <FabeInputText
                                    name="phone"
                                    type="tel"
                                    label={trans.phone}
                                    placeholder={trans.required}
                                    value={this.state.phone}
                                    changeHandler={this.handleInputChange}
                                    errorMessage={validation.phone.message}
                                />
                            </div>
                        </div>
                        <div className="flex">
                            <div className={"w-full md:w-3/5 booking-form__input-wrapper " + (validation.email.isInvalid && "has-error")}>
                                <FabeInputText
                                    name="email"
                                    label={trans.email}
                                    placeholder={trans.required}
                                    value={this.state.email}
                                    changeHandler={this.handleInputChange}
                                    errorMessage={validation.email.message}
                                />
                            </div>
                        </div>
                        <div className="flex flex-wrap">
                            <div className="w-full booking-form__input-wrapper">
                                <label className="checkbox">
                                    <span className="checkbox__title">{trans.remember_contact_info}</span>
                                    <input type="checkbox" name="rememberInfoChecked" onChange={this.handleCheckboxChange} checked={this.state.rememberInfoChecked} value={this.state.rememberInfoChecked} />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="w-full xl:w-1/3">
                    <BookingSummary
                        services={this.state.services}
                        total={this.getTotal()}
                        clients={this.state.clientsCount}
                    />
                </div>
                <div className="w-full xl:hidden booking-form__sticky-total fixed pin-b pin-l bg-white">
                    <div className="container flex items-center justify-between">
                        <div className="w-1/3 booking-form__total text-left">
                            {trans.total}: {trans.currency_prepend}{this.getTotal()}{trans.currency_append}
                        </div>
                        <button type="submit" className="w-2/3 booking-form__cta btn btn-red">
                            {trans.make_appointment}
                        </button>
                    </div>
                </div>
            </form>
        );
    }

    renderLoadingScreen() {
        return (
            <LoadingScreen
                title={trans.processing_order}
                content={<span>{trans.this_may_take_a_while}<br/>{trans.do_not_close_window}</span>}
            />
        )
    }

    renderSuccess() {
        return (
            <BookingSuccess email={this.state.email} phone={this.state.phone}
                boutiques={this.state.boutiques} services={this.state.services} />
        )
    }

    renderModalBoutiques() {
        return (
            <ModalSelect id="modal-select-boutique"
                    title={trans.modal_select_boutique_title}
                    subtitle={trans.modal_select_boutique_subtitle}
                    type="boutique"
                    items={this.state.boutiques}
                    changeHandler={this.handleBoutiquesChange}
                    dismissHandler={() => {this.setState({showModalSelectBoutique: false})}} />
        )
    }

    renderModalProfessionals() {
        return (
            <ModalSelect id="modal-select-professional"
                    title={trans.modal_select_professional_title}
                    subtitle={trans.modal_select_professional_subtitle}
                    type="professional"
                    items={this.state.professionals}
                    changeHandler={this.handleProfessionalsChange}
                    dismissHandler={() => {this.setState({showModalSelectProfessionals: false})}} />
        )
    }

    renderModalServices() {
        return (
            <ModalServices
                id="modal-select-professional"
                title={'Search services'}
                subtitle={'Search services and add to you booking'}
                inputText={this.state.searchText}
                addServiceHandler={this.handleServiceAddClick.bind(this)}
                changeHandler={this.handleProfessionalsChange}
                dismissHandler={() => {this.setState({showModalSelectServices: false})}}
            />
        )
    }

    render() {
        return (
            <div>
                { this.state.success ? this.renderSuccess() : this.renderForm() }
                { this.state.loading && this.renderLoadingScreen() }

                { this.state.showModalSelectProfessionals && this.renderModalProfessionals() }
                { this.state.showModalSelectBoutique && this.renderModalBoutiques() }
                { this.state.showModalSelectServices && this.renderModalServices() }
            </div>
        );
    }
}

export default BookingForm;



// WEBPACK FOOTER //
// ./scripts/components/BookingForm.jsx